/* @flow */

import * as React from 'react';
import { Link } from 'react-router-dom';
import type { TranslatorProps } from 'react-i18next';

import styles from './AccountCardInfo.module.scss';

type TypeProps = {
  name: string,
  icon: React.Element<*>,
  value: number,
  link: ?string | ?Object,
  disabled?: boolean,
};

function AccountCardInfo(props: TypeProps) {
  const disabled = props.disabled;
  return (
    <Link
      to={props.link ? props.link : ''}
      className={`${styles['account-info-element']} ${disabled ? styles.asDisabled : ''}`}
    >
      <div className={styles['info-icon']}>{props.icon}</div>
      <div className={styles['info-value']}>{props.value}</div>
      <div className={styles['info-name']}>{props.name}</div>
    </Link>
  );
}

export default AccountCardInfo;
